<div class="trg-card-list">
  <ng-content></ng-content>
</div>
